import { createContext } from 'react';
import { emptyFunction } from './utils';
const FlowContext = createContext({
    isLogin: null,
    setIsLogin: emptyFunction,
});
export default FlowContext;
